export function updateAutoTopUpV3(send) {
  return (sourceAccountId, body, ...args) =>
    send(
      {
        path: '/v3/sourceAccounts/{sourceAccountId}/updateAutoTopUp',
        pathParameters: { sourceAccountId },
        type: 'post',
        query: undefined,
        body: body,
        headers: undefined,
        auth: 'oauth2',
        contentType: 'application/json',
      },
      ...args
    );
}
